import React from 'react';
import { 
  Box, 
  Typography, 
  useTheme, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  Button
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: 600,
  fontSize: '0.9rem',
  padding: '16px 8px',
  textAlign: 'center',
  borderBottom: `2px solid ${theme.palette.primary.dark}`,
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '2px',
    background: `linear-gradient(90deg, transparent, ${theme.palette.primary.light}, transparent)`,
    opacity: 0.5
  },
  '& br': {
    marginBottom: '4px'
  }
}));

const StyledBodyTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.85rem',
  padding: '8px 8px',
  '& br': {
    marginBottom: '4px'
  },
  '& ul': {
    margin: 0,
    paddingLeft: '20px'
  },
  '&:first-of-type': {
    fontWeight: 600,
    color: theme.palette.primary.main,
    borderRight: `1px solid ${theme.palette.divider}`
  },
  '& strong': {
    color: theme.palette.primary.main
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
    transition: 'background-color 0.2s ease',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const platformData = [
  {
    platform: 'NEXT BASKET',
    prices: '$10 Nigeria & Gana\n$29 Other countries\n7% when NEXT BASKET manages the Partner\'s online business\n1% за NB PRO (large online stores)',
    features: '·Integrated ERP and WMS system\n·AI based search engine and chatbot\n·Continuous full online store management via AI secretary\n·Implemented full SEO and over 350 features and integrations\n·Drag & Drop Builder\n·Wholesale (B2B) enabled\n·Prepared for marketplace platform\nScore: 9/10',
    businessModel: '·SaaS pricing models from low to high end\n·"Business without employees" (7% of revenue)\n·No transaction fees unlike other Platforms\n·GLOBAL business model ·Asian manufacturers sell into Europe and the Rim (7% of revenue)\n·NB PRO plan for large online stores only (1% ·4% of revenue)\nScore: 9/10',
    easeOfUse: '·Create a basic online store in 3 min even on smart phone\n·Personal consultant and 24/7 support\n·Intuitive administration\n·Multiple automations for sales and marketing (almost no manual intervention ·drop that)\n·Dran-n-Drop page builder\nScore: 9/10',
    scalability: '·Withstands very high traffic and peak sales\n·Guaranteed uptime 99.995%\n·Automatic server scaling\n·No resource limits (users, storage, trafic)\n·Free Hosting + Automatic SSL Certificate.\nScore: 9/10',
    globalExpansion: '·Offers global logistics\n·Outlet from one European country to another 26 countries (online store + warehouse)\n·Multilingual and multilingual\n·Optimized for easy import/export\n·Upcoming expansion into the USA and UK\nScore: 10/10',
    integrations: '·Wide range of built-in integrations (ERP, couriers, payments, marketing)\n·API for additional connections\n·Integrations with Analytics, Pixel, Tag manager\n·Multiple marketing integrations\n·Pre-emptive deployment of a proprietary AI engine for complete marketing automation\n·Cryptocurrency payments\nScore: 9/10'
  },
  {
    platform: 'Shopify',
    prices: 'Basic  $27/month,\nGrow $74/month,\nAdvanced $384/month„\nPlus 2% turnover fee\nShopify Plus for Enterprise (from $2300/month)',
    features: '·Hosted SaaS platform ·Thousands of apps in the App Store\n·New AI features (descriptions, chat)\n·Built-in blog, POS, marketing\nScore: 8/10',
    businessModel: 'SaaS pricing models + subscriptions for additional APPs\nScore: 7/10',
    easeOfUse: '·Drag-and-drop shop in 1-2 hours\n·24/7 support (chat, phone)\n·Great communiqués and documentation\nScore: 9/10',
    scalability: '·High performance, accommodates high traffic\n·Automatic cloud hosting, SSL and PCI-DSS certification\n·Reliable for small and large shops\nScore: 8/10',
    globalExpansion: '·Shopify Markets localization (20 languages, 130+ currencies)\n·Many local payment/delivery modules\n·Easy global implementation\nScore: 9/10',
    integrations: '·Over 8000 official applications\n·Native integrations (Facebook, Instagram, Amazon)\n·REST API for external services\nScore: 9/10'
  },
  {
    platform: 'WooCommerce\n(WordPress)',
    prices: 'Open-source\nSmall Store $30-$100\nMedium Store $100 -  $400\nLarge Store $500-$1 000',
    features: '·Open source plugin for WordPress\n·Almost unlimited customization\n·Powerful blog/SEO features (WordPress) Relies on additional plugins (ERP, caching, etc.)\nScore: 7/10',
    businessModel: '·Free plugin, but hosting/domain needed\n·Paid extensions/themes No transaction fees ·Suitable for a small budget but rising costs when scaling\nScore: 7/10',
    easeOfUse: '·Moderate learning curve\n·No centralized support ·mainly forums ·Developed community + documentation\nScore: 6/10',
    scalability: '·Depends on hosting and configuration\n·With proper optimization ·accommodates large stores Security is owner\'s responsibility (updates)\nScore: 7/10',
    globalExpansion: '·Multilingual via plugins (WPML, Polylang) ·Multilingual also via additional plugins\n·Wide localization set, but with manual setup\nScore: 7/10',
    integrations: '·Thousands of extensions and themes\n·API for any external connections Integrations with the most popular ERP/CRM\nScore: 8/10'
  },
  {
    platform: 'Magento\n(Adobe Commerce)',
    prices: 'Open-source\nOver $30 000',
    features: '·Powerful system (multi-store, B2B, complex catalogues)\n·Suitable for large corporations\n·Strong marketing/promo modules Extremely extensible and flexible\nScore: 9/10',
    businessModel: '·Open Source (free) or Adobe Commerce (expensive license)\n·Budget for hosting and programmers\n·No transaction fees, but large development costs\nScore: 7/10',
    easeOfUse: '·Complicated for beginners\n·Commonly implemented by agencies/programmers Admin panel rich in options but difficult for a layman\nScore: 6/10',
    scalability: '·Designed for large loads (multi-server)\n·Full Page Cache, High Performance With regular updates ·secure, but requires expert support\nScore: 9/10',
    globalExpansion: '·Multi-Store, multilingual and default currencies ·Easy localization for global markets\n·Fast growth in different countries\nScore: 9/10',
    integrations: '·3000+ official modules, huge marketplace\n·Easy integration with ERP/CRM (SAP, MS Dynamics) Rich API, large partner network\nScore: 9/10'
  },
  {
    platform: 'BigCommerce',
    prices: 'Standard $39/month,\nPlus $105/month,\nPro $399/month\n(up to $400k annual turnover),\nEnterprise - Custom price',
    features: '·SaaS with rich built-in features (SEO, coupons, B2B)\n·Multi-channel selling (Amazon, eBay)\n·Less need for external applications\n·Good marketing tools\nScore: 8/10',
    businessModel: 'SaaS pricing model with limitation of the turnover\n·No transaction fees\n·Enterprise for higher turnover\nScore: 7/10',
    easeOfUse: '·Moderately easy admin panel\n·24/7 support (phone, chat) Most settings are built-in, which helps non-technical persons\nScore: 8/10',
    scalability: '·Can handle high traffic, 99.99% uptime\n·PCI Level 1, automatic updates Suitable for growing and mid-sized businesses\nScore: 8/10',
    globalExpansion: '·Multi-Storefront, multi-currency (but not always multilingual out of the box)\n·Easy implementation of global payments High level of localization when needed\nScore: 8/10',
    integrations: '·~1500+ applications (ERP, CRM, Marketing)\n·Open API (REST), integrations with MS Dynamics, NetSuite\n·Headless front-end capabilities\nScore: 8/10'
  },
  {
    platform: 'Wix eCommerce',
    prices: 'Light (Get the basics) $17/month,\nCore (Engage your audience)\n$29/month, Business (Grow your brand)\n$36/month, Business Elite (Scale your business)  $159/month',
    features: '·Drag-and-drop design with ready-made templates\n·Basic e-commerce features, AI page generator\n·SEO tools (Wix SEO Wiz)\n·Suitable for smaller catalogs\nScore: 7/10',
    businessModel: 'SaaS pricing model\n·No % sales tax\n·Monthly subscription only\nScore: 7/10',
    easeOfUse: '·Extremely easy visual editor\n·24/7 support for the higher plans Quick to set up a basic store\nScore: 9/10',
    scalability: '·Good uptime for low/medium traffic\n·Hosted and automatically updated by Wix Not for very large catalogs (50k+ items)\nScore: 6/10',
    globalExpansion: '·Additional languages can be added, but 1 main currency\n·Suitable for a limited number of markets\n·No full B2B functionality or 1-day fulfillment\nScore: 6/10',
    integrations: '·App store (App Market) with dozens of add-ons ·Integrations with Printful, Modalyst, QuickBooks\n·Smaller selection of integrations compared to Shopify\nScore: 7/10'
  },
  {
    platform: 'Squarespace',
    prices: 'Personal €15/month\nBusiness €24/month\nCommerce Basic €28/month\nCommerce Advanced €42/month',
    features: '·Beautiful design templates, focus on brand image\n·Basic store + blog\n·Suitable for digital products, services, small catalog\n·AI assistant (Design Intelligence) for content\nScore: 7/10',
    businessModel: '·Commerce plans $36 (Basic) or $65 (Advanced) ·No Commerce transaction fee\n·Business plan (cheaper) has a 3% fee\nScore: 6/10',
    easeOfUse: '·Very easy editor (sectional)\n·24/7 email and chat (no phone)\n·Limited e-commerce settings compared to Shopify\nScore: 8/10',
    scalability: '·Hosted by Squarespace (automatic updates)\n·PCI compliant, SSL enabled\n·Not for very large stores/traffic\nScore: 6/10',
    globalExpansion: '·One currency per store, no multicurrency built-in\n·Multilingualism via duplicate pages\n·Harder with global development\nScore: 5/10',
    integrations: '·Limited Extensions ·QuickBooks, ShipStation, etc.\n·No big marketplace Lacks deep ERP/CRM integrations\nScore: 5/10'
  },
  {
    platform: 'PrestaShop',
    prices: 'Open-source\nSmall Store $20-$75\nMedium Store $50 -$200\nLarge Store $300-$700',
    features: '·Free software with many built-in features\n·Multilingual and multicurrency right out of the box\n·Strong promo/marketing options, flexible B2C Light on resources but upgradeable with modules\nScore: 8/10',
    businessModel: '·Zero licence cost\n·Paid modules/topics as needed Self-hosting (cost from $5-$50+ /month)\nScore: 8/10',
    easeOfUse: '·Initial setup is more complex than SaaS\n·No official support, but there is an expert network Admin panel intuitive for an experienced user\nScore: 6/10',
    scalability: '·Able to serve medium-sized stores (thousands of products)\n·Need caching/optimization for high loads\n·Regular security updates\nScore: 7/10',
    globalExpansion: '·Oriented to EU markets, excellent VAT settings\n·Multi-store, multi-language Popular in Europe for cross-boarder trading\nScore: 8/10',
    integrations: '·Over 3000+ modules in PrestaShop Addons\n·Easy integrations with payments, couriers, marketing\n·Open source, API for ERP/CRM\nScore: 8/10'
  },
  {
    platform: 'OpenCart',
    prices: 'Open-source\nSmall Store $25-$60\nMedium Store $50 -$150\nLarge Store $150-$300',
    features: '·Light open platform\n·Supports multilingual/currency by default\n·Basic e-commerce features + coupons Suitable for small/medium stores\nScore: 7/10',
    businessModel: '·The software is free\n·Paid expansion modules\n·Economical choice with cheap hosting\nScore: 8/10',
    easeOfUse: '·Relatively easy admin panel\n·No official support, forums only Suitable for users with basic technical skills\nScore: 7/10',
    scalability: '·Good speed on weak hosting\n·For many products/orders a more powerful server is needed\n·Regular updates, but security depends on the owner\nScore: 6/10',
    globalExpansion: '·Multi-Store function for several markets\n·No automatic translations, but easy addition of language packs Suitable for initial global expansion\nScore: 6/10',
    integrations: '·Over 13 000 extensions (payments, deliveries)\n·API for connection to ERP/CRM Easily add local suppliers\nScore: 8/10'
  },
  {
    platform: 'Salesforce Commerce Cloud',
    prices: 'Starter Suite $25/Month,\nPro Suite $100/Month,\nCommerce Cloud Pay-As-You-Go - 1% gross merchandise value',
    features: '·Enterprise SaaS for large retailers\n·Built-in AI (Einstein), omni-channel tools\n·Multi-site, advanced marketing and promotions\n·Extremely rich functionality\nScore: 10/10',
    businessModel: '·Corporate license (expensive, 6-7 figures/year)\n·Fee according to turnover/volume of orders\n·Project implementation through partners\nScore: 6/10',
    easeOfUse: '·Not for beginners ·complex integration\n·Premium support and training available\n·Daily work through a convenient admin for professionals\nScore: 6/10',
    scalability: '·Automatic scaling for millions of orders\n·PCI, GDPR, high level security\n·99.99%+ uptime, global CDN\nScore: 10/10',
    globalExpansion: '·Easily manage multiple countries/windows\n·Multilingual, multilingual, local settings Optimized for global brands\nScore: 10/10',
    integrations: '·Deep integration into the Salesforce ecosystem\n·Official "cartridges" for ERP, payments, social channels\n·One of the richest enterprise APIs\nScore: 10/10'
  }
];

const Comparison = () => {
  const theme = useTheme();

  const formatContent = (content: string) => {
    return content.split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <Box id="comparison" sx={{ mb: 8 }}>
      <br /><br /><br />
      <Typography
        variant="h4"
        align="center"
        sx={{
          mb: 3,
          fontWeight: 700,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.dark} 70%, #1a4b80 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textTransform: 'uppercase',
          '&::after': {
            content: '""',
            display: 'block',
            width: '60px',
            height: '4px',
            backgroundColor: theme.palette.primary.main,
            margin: '16px auto 0',
            borderRadius: '2px'
          }
        }}
      >
        Comparison with competitors
      </Typography>
<Typography
        variant="subtitle2"
        sx={{
          textAlign: 'center',
          color: 'text.secondary',
          fontSize: { xs: '0.85rem', sm: '0.9rem' },
          opacity: 0.8,
          mb: { xs: 3, sm: 4, md: 5 }
        }}
      >
        1 slide available
      </Typography>
      <TableContainer 
        component={Paper} 
        sx={{ 
          mt: 4, 
          maxHeight: '600px',
          overflowY: 'auto',
          overflowX: 'auto',
          background: (theme) => `linear-gradient(to bottom, ${theme.palette.background.paper}, ${theme.palette.background.default})`,
          borderRadius: 2,
          boxShadow: (theme) => `0 4px 20px ${theme.palette.primary.main}15`,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: (theme) => theme.palette.background.paper,
          },
          '&::-webkit-scrollbar-thumb': {
            background: (theme) => theme.palette.primary.main,
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: (theme) => theme.palette.primary.dark,
          }
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Platform</StyledTableCell>
              <StyledTableCell>Prices<br/>(Monthly fee)</StyledTableCell>
              <StyledTableCell>Features<br/>(1-10)</StyledTableCell>
              <StyledTableCell>Business Model<br/>(1-10)</StyledTableCell>
              <StyledTableCell>Easy of use<br/>(1-10)</StyledTableCell>
              <StyledTableCell>Scalability and Security<br/>(1-10)</StyledTableCell>
              <StyledTableCell>Global Expansion<br/>(1-10)</StyledTableCell>
              <StyledTableCell>Integrations<br/>(1-10)</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {platformData.map((row, index) => (
              <StyledTableRow key={index}>
                <StyledBodyTableCell>{row.platform}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.prices)}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.features)}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.businessModel)}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.easeOfUse)}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.scalability)}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.globalExpansion)}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatContent(row.integrations)}</StyledBodyTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            const link = document.createElement('a');
            link.href = '/NEXTBASKET_Competitors_Comparison.pdf';
            link.download = 'NEXTBASKET_Competitors_Comparison.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
          startIcon={<DownloadIcon />}
          sx={{
            py: { xs: 1.75, md: 1.75 },
            px: { xs: 4, md: 5 },
            minWidth: { xs: 'auto', md: '300px' },
            borderRadius: 15,
            textTransform: 'none',
            fontSize: { xs: 18, md: 17 },
            fontWeight: 600,
            letterSpacing: '0.02em',
            position: 'relative',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: '#fff',
            border: '1px solid rgba(63, 160, 255, 0.3)',
            backdropFilter: 'blur(8px)',
            zIndex: theme.zIndex.modal + 1,
            '& .MuiSvgIcon-root': {
              color: '#fff',
              fontSize: '1.4rem',
              marginRight: '8px',
              transition: 'transform 0.3s ease'
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)',
              transform: 'translateX(-100%) skewX(-15deg)',
              transition: 'transform 0.7s ease'
            },
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              boxShadow: '0 8px 25px rgba(63, 160, 255, 0.4)',
              transform: 'translateY(-2px)',
              border: '1px solid rgba(63, 160, 255, 0.5)',
              '& .MuiSvgIcon-root': {
                transform: 'scale(1.1) rotate(-10deg)'
              },
              '&::before': {
                transform: 'translateX(100%) skewX(-15deg)'
              }
            },
            '&:active': {
              transform: 'translateY(1px)',
              boxShadow: '0 4px 15px rgba(63, 160, 255, 0.3)'
            }
          }}
        >
          Download PDF
        </Button>
      </Box>
    </Box>
  );
};

export default Comparison;
